import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Product } from '../../models/products.model';  // Importamos la interfaz Product
import { environment } from '../../../environments/environment';  // Importamos el entorno
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ProvidersService {
  private apiUrl = environment.apiUrl;  // Usamos la URL del entorno
  private routerApi = 'api/providerUs';  // Usamos la URL de la API de productos

  constructor(private http: HttpClient, private authService: AuthService) {}

  // Obtener productos con filtros
  getProviders(page: string): Observable<any> {
    const token = this.authService.getUserData()?.token;

    const headers = new HttpHeaders({
        'Authorization': `Bearer ${token}`
    });
    return this.http.get<any>(`${this.apiUrl}/${this.routerApi}/${page}`, { headers });
  }
   // Obtener productos con filtros
   getProvidersAll(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${this.routerApi}/providerAll`);
  }
   // Obtener un provider por ID
   getProviderById(id: any): Observable<any> {
    const token = this.authService.getUserData()?.token;

    const headers = new HttpHeaders({
        'Authorization': `Bearer ${token}`
    });
    // Usa `page` como un parámetro de ruta y los filtros como parámetros de consulta
    let params = new HttpParams();
    return this.http.get<any>(`${this.apiUrl}/${this.routerApi}/provider/${id}`, { headers, params });
  }
    // Crear un nuevo producto
    createProvider(provider: any): Observable<any> {
      const token = this.authService.getUserData()?.token;

      const headers = new HttpHeaders({
          'Authorization': `Bearer ${token}`    });
      // Usa `page` como un parámetro de ruta y los filtros como parámetros de consulta
      let params = new HttpParams();

      return this.http.post<any>(`${this.apiUrl}/${this.routerApi}`, provider, { headers, params });
    }
  // Actualizar un producto
  updateProvider(id: number, product: any): Observable<any> {
    const token = this.authService.getUserData()?.token;

    const headers = new HttpHeaders({
        'Authorization': `Bearer ${token}`    });
    // Usa `page` como un parámetro de ruta y los filtros como parámetros de consulta
    let params = new HttpParams();
    return this.http.put<any>(`${this.apiUrl}/${this.routerApi}/${id}`, product, { headers, params });
  }

  // Eliminar un producto
  deleteProvider(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${this.routerApi}/${id}`);
  }

  updateMapView(id: string): Observable<any> {
    const token = this.authService.getUserData()?.token;

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
    let params = new HttpParams();
    return this.http.put<any>(`${this.apiUrl}/${this.routerApi}/addMapClick/${id}`, {}, { headers, params });
  }

  updateAddView(id: string): Observable<any> {
    const token = this.authService.getUserData()?.token;

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
    let params = new HttpParams();
    return this.http.put<any>(`${this.apiUrl}/${this.routerApi}/addView/${id}`, {}, { headers, params });
  }
}